import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Pill, CurrencyInr } from "@phosphor-icons/react";

export default function Pharmacy() {
  const [meds, setMeds] = useState([]);
  const [q, setQ] = useState("");
  const [genericOnly, setGenericOnly] = useState(false);

  const load = () => api.get("/pharmacy/medicines", { params: { q, generic_only: genericOnly } }).then((r) => setMeds(r.data));
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [q, genericOnly]);

  return (
    <div className="p-6 md:p-12 pb-24 md:pb-12">
      <div className="mb-8">
        <div className="overline text-terracotta">Verified pharmacy partners</div>
        <h1 className="font-heritage text-5xl text-ayurveda mt-1">Pharmacy</h1>
        <p className="text-charcoal/70 mt-2">Jan Aushadhi & generic pricing shown for affordability. Prescription drugs require a valid clinician prescription.</p>
      </div>

      <div className="flex items-center gap-4 mb-6">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search medicine…" className="max-w-xs bg-white" data-testid="pharmacy-search" />
        <div className="flex items-center gap-2">
          <Switch id="generic" checked={genericOnly} onCheckedChange={setGenericOnly} data-testid="pharmacy-generic-toggle" />
          <Label htmlFor="generic" className="text-sm">Generic / Jan Aushadhi only</Label>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {meds.map((m) => (
          <Card key={m.id} className="border-black/5 bg-white hover:-translate-y-0.5 transition-transform" data-testid={`med-${m.id}`}>
            <CardContent className="p-5 space-y-2">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-clinical text-lg text-ayurveda">{m.name}</div>
                  <div className="text-xs text-charcoal/60">{m.generic_name} · {m.form}</div>
                </div>
                <Pill size={20} weight="duotone" className="text-terracotta" />
              </div>
              <div className="flex items-center gap-2">
                <Badge variant="outline" className="text-[10px]">{m.category}</Badge>
                {m.rx_required && <Badge className="bg-terracotta text-white text-[10px]">Rx</Badge>}
                {m.is_generic && <Badge className="bg-ayurveda text-bone text-[10px]">Generic</Badge>}
              </div>
              <div className="flex items-center justify-between pt-2 text-sm">
                <div>
                  <div className="text-xs text-charcoal/50">Market</div>
                  <div className="font-clinical text-ayurveda flex items-center"><CurrencyInr size={14} />{m.price_inr}</div>
                </div>
                <div>
                  <div className="text-xs text-terracotta">Jan Aushadhi</div>
                  <div className="font-clinical text-terracotta flex items-center"><CurrencyInr size={14} />{m.jan_aushadhi_price}</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
